import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import $ from 'jquery';

import { selectUrlData } from '../../redux/train/train.selector';

import iconBack from '../../assets/back-arrow.png';
import iconClose from '../../assets/close.png';

class FaqDetailsRefund extends React.Component {
    constructor(props) {
        super(props);
        window.jQuery = $;
        window.$ = $;
        global.jQuery = $;
    }
    myFunction(e) {
        $('.single-faq').removeClass('active');
        $(e).parent('.single-faq').addClass('active');
    }
    render() {
        const { urlData } = this.props;
        return (
            <div>
                <div className="faq-header">
                    <a href={'/ttbhelp?' + urlData}><img src={iconBack} alt="" title="" /></a>
                    <h2>Frequently Asked Questions(FAQ):</h2>
                    <Link to={'/ttbhelp/faq'}><img src={iconClose} alt="" title="" /></Link>
                </div>
                <div className="faq-content">
                    <h4>Refunds and Cancellations</h4>

                    <h2>What do you need help with?</h2>

                    <div className="faq-accordian">
                        <div className="single-faq active">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How do I cancel my train ticket?</h3>
                            <p>Cancellation</p>
                            <p>RailYatri App:</p>

                            <li>Open the <span>RailYatri app</span> and go to the <span>"My Bookings"</span> section.</li>
                            <li>Select the ticket you wish to cancel.</li>
                            <li>Click on <span>"Cancel Ticket"</span> and confirm the cancellation.</li>
                            <li>You will receive a cancellation confirmation and communication from RailYatri about the booking status.</li>


                            <p>Refund Process</p>
                            <p>Refunds are generally processed within <span>7-10 business days</span>. The exact time may vary depending on your payment method.</p>
                            <p>You can track the refund status on refunds.railyatri.in.</p>

                            <p>
                                <strong>Note:</strong> The refund processing time may vary, so checking the refund status periodically is recommended.
                            </p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>What is the refund policy for canceled tickets?</h3>
                            <p>Refund Process</p>
                            <p>Refunds are typically processed within 7-10 business days, but this can vary depending on your payment method and you can track the refund status in refunds.railyatri.in"</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>Why was my ticket auto-canceled, and when will I receive my refund?</h3>
                            <p>Your ticket might have been auto-canceled for several reasons:</p>

                            <li>Waitlisted Status: If your ticket remained waitlisted after the final chart preparation, it would have been auto-canceled by the system.</li>

                            <li>Payment Issues: If there was a problem with the payment during the booking process, such as a failed transaction, the booking might have been auto-canceled after 1 hour.</li>

                            <li>Technical Errors: Sometimes, technical issues can cause an auto-cancellation, resulting in the booking not being completed.</li>

                            <p>If your ticket was auto-canceled, the refund will generally be processed automatically. You can expect to receive it within 7-10 business days, though the exact time may vary depending on your payment method and bank processing times. Track your refund status in refund.railyatri.in</p>

                            <p>If you do not receive your refund within this timeframe, please reach out to customer support for assistance.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>What should I do if my TDR was approved but the refund is still pending?</h3>
                            <p>If your TDR (Ticket Deposit Receipt) was approved but the refund is still pending, here’s what you can do:</p>

                            <li>Check the Status: First, verify the status of your TDR and refund through the RailYatri app, IRCTC website, or by contacting the customer support of the booking platform you used. Sometimes, the refund might be processed but not yet reflected in your account.</li>

                            <li>Contact Customer Support: If the refund is confirmed as pending, reach out to the customer support team of the platform where you booked the ticket (RailYatri, IRCTC, etc.). Provide them with the TDR number and other relevant details to expedite the process.</li>

                            <p>Typically, refunds are processed within a few business days after TDR approval, but delays can occur due to various factors. Regular follow-up can help ensure that your refund is processed as soon as possible.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>What is the process for filing a TDR?</h3>
                            <p>1. Select the Ticket in the "My Bookings" in RailYatri app/website.</p>
                            <p>Find the ticket for which you need to file a TDR. Click on the relevant ticket to view details and selected the "Cancel Ticket" option and navigate to "File TDR".</p>
                            <p>2. Select the passenger and choose the reason for filing a TDR and Submit the request."</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>Will I get a refund if I cancel my Tatkal ticket?</h3>
                            <li>1. Cancellation of Confirmed Tatkal Tickets:</li>
                            <p>No Refund: If you cancel a confirmed Tatkal ticket, no refund will be provided, as per Indian Railways' rules. This applies whether you cancel the ticket well in advance or close to the departure time.</p>

                            <li>2. Cancellation of Waitlisted Tatkal Tickets:</li>
                            <p>Full Refund: If your Tatkal ticket is waitlisted and you cancel it, you are eligible for a full refund.</p>

                            <li>3. Cancellation Due to Train Cancellation:</li>
                            <p>Full Refund: If the train is canceled by Indian Railways, you will receive a full refund, even if it’s a confirmed Tatkal ticket. You can claim this by filing a TDR.</p>

                            <li>4. Partial Confirmation:</li>
                            <p>Refund for Waitlisted Passengers Only: If your Tatkal ticket is partially confirmed (e.g., some passengers are confirmed, and others are waitlisted), you can cancel the ticket. A refund will be issued only for the waitlisted passengers."</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How long does it take to process a refund after filing a TDR?</h3>
                            <p>After filing a TDR (Ticket Deposit Receipt), the refund process usually takes 7-10 business days, but can vary based on:</p>

                            <li>1. Reason for TDR Filing: Cases like train cancellations or railway faults may need more verification.</li>
                            <li>2. Approval by Indian Railways: Refunds are subject to their review and approval.</li>
                            <li>3. Bank Processing Time: Once approved, the time to reflect in your account depends on your bank or payment provider.</li>

                            <p>Steps to Take If Refund Is Delayed:</p>

                            <li>Track TDR status via the RailYatri app or IRCTC.</li>
                            <li>Contact support for assistance.</li>
                            <li>Follow up with your bank if needed.</li>
                            <li>While 7-10 business days is typical, staying proactive by tracking your TDR status can help ensure a smooth refund process</li>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How do I get a refund for a duplicate booking?</h3>
                            <p>Step 1: Confirm the duplicate booking by checking the "My Bookings" section in the RailYatri app.</p>
                            <p>Step 2: Cancel the duplicate ticket by selecting it in "My Bookings," and then confirm the cancellation.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How does the free cancellation service work?</h3>
                            <p>The Free Cancellation Service allows you to cancel your train booking without incurring the usual cancellation charges. Here’s how it works:</p>

                            <li> 1. Opt for Free Cancellation During Booking:<br />
                                When booking your train ticket through the RailYatri app, you'll see an option to add the Free Cancellation Service.
                                Select this option if you want to protect yourself from cancellation fees in case your plans change.</li>

                            <li> 2. Cancel Your Ticket:<br />
                                If you need to cancel your booking, go to the "My Bookings" section in the RailYatri app or website.
                                Select the ticket you want to cancel and proceed with the cancellation process.</li>

                            <li>3. Full Refund (No Cancellation Fees):<br />
                                With the Free Cancellation Service, you’ll receive a full refund of the ticket fare without any cancellation charges.
                                The service ensures that the typical Indian Railways cancellation charges are waived.</li>

                            <li>Important Notes:<br />
                                The Free Cancellation Service is applicable only if you’ve selected it while booking the ticket.
                                Some conditions may apply, such as a time frame within which you need to cancel to avail of the free cancellation.</li>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>I have been charged an excess amount. How do I get it refunded?</h3>
                            <p>1. Check Your Booking Details:<br />
                                Ensure that the excess amount charge is not due to any taxes, convenience fees, catering charges, or any add-ons like insurance.
                                Review your booking confirmation email or app for detailed charges.</p>

                            <p>2. Contact RailYatri Customer Support:<br />
                                You can reach RailYatri through the following channels:</p>

                            <p>RailYatri App/Website:<br />
                                Open the RailYatri app or website and navigate to the "Help" or "Support" section and raise a query. You can also request for a callback.</p>

                            <p>Email:<br />
                                Send an email to RailYatri customer support at care@railyatri.in explaining the issue. Include the following details:<br />
                                Booking ID or PNR number or Ref#<br />
                                Date of booking<br />
                                The excess amount charged<br />
                                Any screenshots or receipts of the transaction<br />
                                Contact number<br />
                                Brief Description</p>

                            <p>You can also try calling RailYatri’s customer support helpline 8010 500 300.</p>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}

const mapStateProps = createStructuredSelector({
    urlData: selectUrlData
})

export default connect(mapStateProps, null)(FaqDetailsRefund);
